module.exports = __webpack_public_path__ + "static/04-1a5f25ba1640f22b726874837a0777dd.jpg";